import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {
    amountDataTableTemplate, numberWithCommaDataTableTemplate,
    priceDataTableTemplate, rateDataTableTemplate
} from "../../../../utils/formatters/Numbers";

import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import LoadingOverlay from 'react-loading-overlay';
import PropTypes from "prop-types";

const BilateralMaturityView = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title={"Bilaterales \\ Tablero de Control \\ Vencimiento"}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid item>
                                <Button
                                    label="Aceptar"
                                    style={{'float': 'right'}}
                                    onClick={props.handleAgree}/>
                            </Grid>
                            <Grid item>
                                <Button
                                    label="Cancelar"
                                    style={{'float': 'right'}}
                                    className="p-button-secondary"
                                    onClick={props.handleReturnButton}/>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item xs={12}>
                            <SubtitleLabel header="Préstamo" isBold={true}/>
                        </Grid>
                        <Grid item xs={12}>
                            <DataTable
                                value={props.loanData}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column field="id" header="Folio"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="instrument" header="Emisora"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="title" header="Títulos"
                                        body={numberWithCommaDataTableTemplate} sortable={true}/>
                                <Column field="price" header="Precio"
                                        body={priceDataTableTemplate} sortable={true}/>
                                <Column field="amount" header="Importe"
                                        body={amountDataTableTemplate} sortable={true}/>
                                <Column field="rate" header="Tasa"
                                        body={rateDataTableTemplate} sortable={true}/>
                                <Column field="term" header="Plazo"
                                        body={numberWithCommaDataTableTemplate} sortable={true}/>
                                <Column field="premium" header="Premio"
                                        body={amountDataTableTemplate} sortable={true}/>
                            </DataTable>
                        </Grid>
                        <Grid item xs={12}>
                            <br/><Divider/>
                        </Grid>
                        <Grid item xs={12}>
                            <SubtitleLabel header="Garantías" isBold={true}/>
                        </Grid>
                        <Grid item xs={12}>
                            <DataTable
                                value={props.loanCollaterals}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column field="composeName" header="Emisora"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="title" header="Títulos"
                                        body={numberWithCommaDataTableTemplate} sortable={true}/>
                                <Column field="price" header="Precio Mercado"
                                        body={priceDataTableTemplate} sortable={true}/>
                                <Column field="amount" header="Importe Mercado"
                                        body={amountDataTableTemplate} sortable={true}/>
                            </DataTable>
                        </Grid>
                        {props.confirmationMessage}
                    </Grid>
                </Paper>
            </LoadingOverlay>
        </React.Fragment>
    )
};

export default BilateralMaturityView;

BilateralMaturityView.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object.isRequired,
    handleAgree: PropTypes.func.isRequired,
    handleReturnButton: PropTypes.func.isRequired,
    loanData: PropTypes.array.isRequired,
    loanCollaterals: PropTypes.array.isRequired,
};